import { render } from "./DefaultSvgMinus.vue?vue&type=template&id=3d7c4b7f&scoped=true"
import script from "./DefaultSvgMinus.vue?vue&type=script&lang=js"
export * from "./DefaultSvgMinus.vue?vue&type=script&lang=js"

import "./DefaultSvgMinus.vue?vue&type=style&index=0&id=3d7c4b7f&lang=scss&scoped=true"

import exportComponent from "/Users/carolinehansen/Sites/work-manyone/koebenhavns-kommune/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7c4b7f"]])

export default __exports__